import { render, staticRenderFns } from "./RoseLega.vue?vue&type=template&id=69f8b59c&scoped=true&"
import script from "./RoseLega.vue?vue&type=script&lang=js&"
export * from "./RoseLega.vue?vue&type=script&lang=js&"
import style0 from "./RoseLega.vue?vue&type=style&index=0&id=69f8b59c&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "69f8b59c",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/Users/diego/Desktop/code/asta-live/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('69f8b59c')) {
      api.createRecord('69f8b59c', component.options)
    } else {
      api.reload('69f8b59c', component.options)
    }
    module.hot.accept("./RoseLega.vue?vue&type=template&id=69f8b59c&scoped=true&", function () {
      api.rerender('69f8b59c', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/RoseLega.vue"
export default component.exports